import React from "react";
import { EmbeddedReportPage } from "components";

// Компонент дашборд Prom
const StatsManagerPage = () => {
  return (
    <EmbeddedReportPage
      pageTitle="Статистика менеджерів"
      iframeTitle="Звіт по менеджерах"
      endpointUrl="/reports/managers-stats/embed-url"
    />
  );
};

export default StatsManagerPage;
